import React from "react";
import { useContext } from "react";
import SectionContext from "../../../contexts/SectionContext";
import ModalContext from "../../../contexts/ModalContext";
import VehicleForm from "./vehicleForm";
import VehicleDetail from "./vehicleDetail";

const VehicleContent = ()=>{
    const { setModalActive, modalSection } = useContext(ModalContext)

    if(modalSection.includes('Form')){
        return(<VehicleForm/>) 
    }else{
        return(<VehicleDetail/>)
    }
}
export default VehicleContent;